export const INTRO_MODAL_SWEEP_TOTAL_ENTRIES = "sweepTotalEntries";
export const AUTO_HIDE_INTRO_MODAL_DELAY_SECONDS = 5;
